module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.43.59.a4a5a5eb.jpg";